/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SportGymBarbellIcon20Solid = forwardRef('SportGymBarbellIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 5.5A1.5 1.5 0 0 1 4.5 4h1A1.5 1.5 0 0 1 7 5.5v3.25h6V5.5A1.5 1.5 0 0 1 14.5 4h1A1.5 1.5 0 0 1 17 5.5V6h.5A1.5 1.5 0 0 1 19 7.5v1.75h.25a.75.75 0 0 1 0 1.5H19v1.75a1.5 1.5 0 0 1-1.5 1.5H17v.5a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-3.25H7v3.25A1.5 1.5 0 0 1 5.5 16h-1A1.5 1.5 0 0 1 3 14.5V14h-.5A1.5 1.5 0 0 1 1 12.5v-1.75H.75a.75.75 0 0 1 0-1.5H1V7.5A1.5 1.5 0 0 1 2.5 6H3v-.5Z" })));
});
